// @ts-check
import { createDataGridContext } from '~/components/Shared/ZeroDataGrid/ZeroDataGrid.context';
import { useContext } from "react";

const [SubmissionDataGridContext, SubmissionDataGridContextProvider] = createDataGridContext('submissions');
export { SubmissionDataGridContext, SubmissionDataGridContextProvider };

/** @returns {BaseDataGridContextValue} */
export function useSubmissionDataGridContext() {
    return useContext(SubmissionDataGridContext);
}
